import {
  Box,
  Grid,
  TextField,
  Typography,
  IconButton,
  Button,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
} from "@mui/material";
import {
  freightPayCreate,
  freightListforInvoiceCreation,
} from "../../../Services/Services"; // Adjust the path
import React, { useState, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
const EditFreightPayment = ({
  data = {},
  freightOptions = [],
  branchOptions = [],
  onClose,
  selectedFreight,
}) => {
  const [freightIds, setFreightIds] = useState([]);
  const [branchname, setBranchname] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [paidAmount, setPaidAmount] = useState("");
  const [remAmount, setRemAmount] = useState("");
  const [mergefreight, setFreightOptions] = useState([]);
  const [page, setPage] = useState(1);
const [hasMore, setHasMore] = useState(true);
  const [payments, setPayments] = useState([
    {
      pay_amount: "",
      payment_to: "",
      upi_check_no: "",
      pay_mode: "",
      remark: "",
    },
  ]);

  const [snackOpen, setSnackOpen] = useState(false);
 
  // useEffect(() => {
  //   const fetchFreightList = async () => {
  //     const data = await freightListforInvoiceCreation();
  //     const mergedArray = selectedFreight.concat(data.results || []);

  //     setFreightOptions(mergedArray);
  //   };

  //   fetchFreightList();
  // }, []);
  
useEffect(() => {
  // Initial load
  fetchFreightList(1);
}, []);

const fetchFreightList = async (pageNo = 1) => {
  try {
    const data = await freightListforInvoiceCreation(pageNo); // backend should support ?page=1
    const newData = data.results || [];

    if (pageNo === 1) {
      // Initial load
      setFreightOptions(selectedFreight.concat(newData));
    } else {
      // Load more
      setFreightOptions(prev => [...prev, ...newData]);
    }

    setHasMore(!!data.next); // backend should return next page url or null
    setPage(prev => prev + 1);
  } catch (error) {
    console.error("Error fetching freight list", error);
  }
};

  useEffect(() => {
    if (data) {
      setFreightIds(data.freight_id || []);
      setBranchname(data.branch_name || "");
      setTotalAmount(data.total_amount || "");
      setPaidAmount(data.paid_amount || "");
      setRemAmount(data.rem_amount || "");
      setPayments(
        data.payments?.length > 0
          ? data.payments
          : [
            // {
            //   pay_amount: "",
            //   payment_to: "",
            //   upi_check_no: "",
            //   pay_mode: "",
            //   remark: "",
            // },
          ]
      );
    }
  }, [data]);

  const handlePaymentChange = (index, field, value) => {
    const updated = [...payments];
    updated[index][field] = value;
    setPayments(updated);

    if (field === "pay_amount") {
      const newPaidAmount = updated.reduce((acc, p) => {
        const val = parseFloat(p.pay_amount);
        return acc + (isNaN(val) ? 0 : val);
      }, 0);
      const total = parseFloat(totalAmount) || 0;
      const newRemAmount = total - newPaidAmount;
      setPaidAmount(newPaidAmount.toFixed(2));
      setRemAmount(newRemAmount.toFixed(2));
    }
  };

  const handleRemovePayment = (index) => {
    const updated = [...payments];
    updated.splice(index, 1);
    setPayments(updated);

    const newPaidAmount = updated.reduce((acc, payment) => {
      const val = parseFloat(payment.pay_amount);
      return acc + (isNaN(val) ? 0 : val);
    }, 0);

    const total = parseFloat(totalAmount) || 0;
    const newRemAmount = total - newPaidAmount;

    setPaidAmount(newPaidAmount.toFixed(2));
    setRemAmount(newRemAmount.toFixed(2));
  };



  const handleSubmit = async () => {
    const formData = {
      freight_id: freightIds,
      branch_name: branchname,
      total_amount: parseFloat(totalAmount),
      paid_amount: parseFloat(paidAmount),
      rem_amount: parseFloat(remAmount),
      freight_data:mergefreight,
      payments: payments.map((p) => ({
        pay_amount: parseFloat(p.pay_amount),
        payment_to: p.payment_to,
        upi_check_no: p.upi_check_no,
        pay_mode: p.pay_mode,
        remark: p.remark,
      })),
    };

    try {
      await freightPayCreate(data.freight_payment_id, formData);
      setSnackOpen(true);
      if (onClose) onClose();
    } catch (error) {
      console.error("Error updating payment:", error);
      alert("Failed to update payment");
    }
  };

  const handleIsBillToggle = (freightId) => {
    setFreightOptions((prevOptions) => {
      const updatedOptions = prevOptions.map((row) => {
        if (row.freight_id === freightId) {
          return { ...row, is_invoice: !row.is_invoice };
        }
        return row;
      });

      const newTotal = updatedOptions.reduce((sum, row) => {
        return row.is_invoice ? sum + (parseFloat(row.net_payable) || 0) : sum;
      }, 0);

      const newPaidAmount = payments.reduce((acc, p) => {
        const val = parseFloat(p.pay_amount);
        return acc + (isNaN(val) ? 0 : val);
      }, 0);

      const newRemAmount = newTotal - newPaidAmount;
       const selectedIds = updatedOptions
      .filter((row) => row.is_invoice)
      .map((row) => row.freight_id);

    setFreightIds(selectedIds);
      setTotalAmount(newTotal.toFixed(2));
      setPaidAmount(newPaidAmount.toFixed(2));
      setRemAmount(newRemAmount.toFixed(2));

      return updatedOptions;
    });
  };

  return (
    <Box p={1}>
      <Snackbar
        open={snackOpen}
        autoHideDuration={3000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Payment updated successfully!
        </Alert>
      </Snackbar>

      <Grid
        container
        spacing={2}
        sx={{
          position: "sticky",
          top: -5,
          zIndex: 100,
          backgroundColor: "white",
          // borderBottom: "1px solid #ddd",
          pb: 1,
        }}
      >
        <Grid item xs={3}>
          <TextField
            label="Total amount"
            type="number"
            fullWidth
            value={totalAmount}
            onChange={(e) => {
              setTotalAmount(e.target.value);
              const paid = parseFloat(paidAmount) || 0;
              const total = parseFloat(e.target.value) || 0;
              setRemAmount((total - paid).toFixed(2));
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Paid amount"
            type="number"
            fullWidth
            value={paidAmount}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Rem amount"
            type="number"
            fullWidth
            value={remAmount}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={3}>
          <Box display="flex" justifyContent="flex-center" gap={2}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button variant="outlined" color="secondary" onClick={onClose}>
              Close
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12}>

          {/* <br /> */}
          {payments.map((payment, index) => (
            <Box key={index} display="flex" gap={2} alignItems="center" mb={1}>
              <TextField
                label="Pay amount"
                type="number"
                value={payment.pay_amount}
                onChange={(e) =>
                  handlePaymentChange(index, "pay_amount", e.target.value)
                }
              />
              <TextField
                label="Payment to"
                value={payment.payment_to}
                onChange={(e) =>
                  handlePaymentChange(index, "payment_to", e.target.value)
                }
              />
              <TextField
                label="UPI check no"
                value={payment.upi_check_no}
                onChange={(e) =>
                  handlePaymentChange(index, "upi_check_no", e.target.value)
                }
              />
              <TextField
                label="Pay mode"
                value={payment.pay_mode}
                onChange={(e) =>
                  handlePaymentChange(index, "pay_mode", e.target.value)
                }
              />
              <TextField
                label="Remark"
                value={payment.remark}
                onChange={(e) =>
                  handlePaymentChange(index, "remark", e.target.value)
                }
              />
              <IconButton onClick={() => handleRemovePayment(index)}>
                ✕
              </IconButton>
            </Box>
          ))}
        </Grid>
      </Grid>
      

      <TableContainer 
        component={Paper}
        id="scrollableDiv"
        sx={{
          // maxHeight: "40vh",
          overflow: "auto",
        }}
      >
          <InfiniteScroll
    dataLength={mergefreight.length}
    next={() => fetchFreightList(page)}
    hasMore={hasMore}
   height={300}
    scrollableTarget="scrollableDiv"
  >
        <Table
          stickyHeader
          size="small"
          sx={{
            tableLayout: "auto",
            width: "auto",
            "& td, & th": {
              textAlign: "center",
              whiteSpace: "nowrap",
              padding: "4px 8px",
              fontSize: "0.8125rem",
              borderBottom: "1px solid #ccc",
            },
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                "& th": {
                  fontWeight: "bold",
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <TableCell
                padding="checkbox"
                sx={{
                  position: "sticky",
                  left: 0,
                  zIndex: 10,
                  backgroundColor: "#f5f5f5"
                }}
              ></TableCell>
              <TableCell>SR. No</TableCell>
              <TableCell>Freight Id</TableCell>
              <TableCell>Party Name</TableCell>
              <TableCell>Branch Name</TableCell>
              <TableCell>Loading Date</TableCell>
              <TableCell>Unloading Date</TableCell>
              <TableCell
                sx={{
                  position: "sticky",
                  left: 50,
                  zIndex: 10,
                  // backgroundColor: "#f5f5f5",
                }}
              >
                Truck No.
              </TableCell>
              <TableCell>D.O. No.</TableCell>
              <TableCell>T.P. No.</TableCell>
              <TableCell>From</TableCell>
              <TableCell>To</TableCell>
              <TableCell>Loading Wt</TableCell>
              <TableCell>Receiving Wt</TableCell>
              <TableCell>Shortage Wt</TableCell>
              <TableCell>Billing Wt</TableCell>
              <TableCell>Freight Rate</TableCell>
              <TableCell>Freight Amt</TableCell>
              <TableCell>TDS %</TableCell>
              <TableCell>TDS Amt</TableCell>
              <TableCell>Shortage Rate</TableCell>
              <TableCell>Shortage Amt</TableCell>
              <TableCell>Ad Mines</TableCell>
              <TableCell>Ad Diesel</TableCell>
              <TableCell>Ad Cash</TableCell>
              <TableCell>Total Ad</TableCell>
              <TableCell>Commission</TableCell>
              <TableCell>Net Amt</TableCell>
              <TableCell>Others Exp.</TableCell>
              <TableCell>Net Payable</TableCell>
              <TableCell>Truck Owner</TableCell>
              <TableCell>Phone No.</TableCell>
              <TableCell>PAN No.</TableCell>
              <TableCell>Remark</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mergefreight.map((row, index) => (
              <TableRow
                key={row.freight_id}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                }}
              >
                <TableCell
                  padding="checkbox"
                  sx={{
                    position: "sticky",
                    left: 0,
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  <Checkbox
                    checked={row.is_invoice}
                    onChange={() => handleIsBillToggle(row.freight_id)}
                    size="small"
                  />
                </TableCell>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.freight_id}</TableCell>
                <TableCell>{row.party_name}</TableCell>
                <TableCell>{row.branch_name}</TableCell>
                <TableCell>{row.loading_date}</TableCell>
                <TableCell>{row.unloading_date}</TableCell>
                <TableCell
                  sx={{
                    position: "sticky",
                    left: 50,
                    zIndex: 9,
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  {row.truck_no}
                </TableCell>
                <TableCell>{row.do_no}</TableCell>
                <TableCell>{row.tp_no}</TableCell>
                <TableCell>{row.from_location}</TableCell>
                <TableCell>{row.to_location}</TableCell>
                <TableCell>{row.loading_wt}</TableCell>
                <TableCell>{row.received_wt}</TableCell>
                <TableCell>{row.shortage_wt}</TableCell>
                <TableCell>{row.billing_wt}</TableCell>
                <TableCell>{row.freight_rate}</TableCell>
                <TableCell>{row.freight_amt}</TableCell>
                <TableCell>{row.tds_per}</TableCell>
                <TableCell>{row.tds_amt}</TableCell>
                <TableCell>{row.shortage_rate}</TableCell>
                <TableCell>{row.shortage_amt}</TableCell>
                <TableCell>{row.ad_mines_exp}</TableCell>
                <TableCell>{row.ad_diesel_exp}</TableCell>
                <TableCell>{row.ad_cash_exp}</TableCell>
                <TableCell>{row.total_advance}</TableCell>
                <TableCell>{row.commission}</TableCell>
                <TableCell>{row.net_amount}</TableCell>
                <TableCell>{row.other_exp}</TableCell>
                <TableCell>{row.net_payable}</TableCell>
                <TableCell>{row.truck_owner}</TableCell>
                <TableCell>{row.phone_no}</TableCell>
                <TableCell>{row.pan_no}</TableCell>
                <TableCell>{row.remark}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        </InfiniteScroll>
      </TableContainer>
      
    </Box>
  );
};

export default EditFreightPayment;


